/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var CopyIcon16Solid = forwardRef('CopyIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M13 2.5A2.5 2.5 0 0 0 10.5 0h-6A2.5 2.5 0 0 0 2 2.5v8A2.5 2.5 0 0 0 4.5 13h6a2.5 2.5 0 0 0 2.5-2.5v-8Z" }),
        React.createElement("path", { d: "M15.563 5.5a.75.75 0 0 0-1.5 0v5.206a3.25 3.25 0 0 1-3.25 3.25H6.5a.75.75 0 0 0 0 1.5h4.313a4.75 4.75 0 0 0 4.75-4.75V5.5Z" })));
});
